import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainLayoutComponent } from '@theme/layouts/main-layout/main-layout.component';
// Guard
import { AuthGuardService } from '@app/helpers';

import { MyCompanyDetailsComponent } from './my-company/my-company-details.component';
import { CompanyComponent } from './my-company/company.component';
import { CustomersComponent } from './my-company/customers/customers.component';
import { CompanyUsersComponent } from './my-company/users/company-users.component';
import { OrganizationsComponent } from './organizations/organizations.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      /*{
        path: '',
        pathMatch: 'full',
        redirectTo: '/dashboard',
      },*/
      {
        path: '',
        component: CompanyComponent,
        /*children: [
          {
            path: '',
            redirectTo: '',
            component: MyCompanyDetailsComponent,
            pathMatch: 'full',
          },
          {
            path: 'users',
            component: CompanyUsersComponent,
          },
        ],*/
      },
      {
        path: 'customers',
        component: CustomersComponent,
      },
      {
        path: 'companies',
        component: OrganizationsComponent
      },
      {
        path: 'my-company',
        component: MyCompanyDetailsComponent
      },
      {
        path: 'company/:id',
        component: CompanyComponent,
        children: [
          {
            path: '',
            redirectTo: '',
            component: MyCompanyDetailsComponent,
            pathMatch: 'full',
          },
          {
            path: 'users',
            component: CompanyUsersComponent,
          },
          {
            path: 'plan',
            // component: ProductsComponent,
          },
          {
            path: 'info',
            redirectTo: '',
          }
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganizationRoutingModule {}
